import Dashboard from "../../Pages/Dashboard";


const navigation = {
  header: "Dashboard",
  links: [
    {
      text: "Dashboard",
      icon: <></>,
      route: "",
      component: Dashboard,
    },
  ],
};


export default navigation;
